
const covertDecimalPrice = (price) => {
    return Number(Number(price).toFixed(2));
}

export default covertDecimalPrice;